export const NETWORK = ['Mainnet', 'Testnet'];

export const MAINNET = {
  networkName: 'Mainnet',
  hexChainId: '0x1',
  chainId: '1',
};
